export default __webpack_public_path__ + "static/media/monaco-svg.083bb69a.svg";